export default __webpack_public_path__ + "static/media/image-086.41ee7eb8.jpg";